import { render, staticRenderFns } from "./ReservationsMessages.vue?vue&type=template&id=588c0b04&scoped=true&"
import script from "./ReservationsMessages.vue?vue&type=script&lang=ts&"
export * from "./ReservationsMessages.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationsMessages.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ReservationsMessages.vue?vue&type=style&index=1&id=588c0b04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c0b04",
  null
  
)

export default component.exports